import { getFlag } from 'sierra-client/config/global-config'
import { useOrganizationPermissions } from 'sierra-client/hooks/use-permissions'

export const useXApiPageEnabled = (): boolean | undefined => {
  const hasPermission = useOrganizationPermissions().has('MANAGE_XAPI_SERVERS')
  const publicApiXApiFlag = getFlag('public-api/x-api')

  return hasPermission && publicApiXApiFlag
}
